import classnames from 'classnames';

import { Banner, ImageCustom } from '@/components';
import { DeviceType } from '@/constant';
import { useAppSelector } from '@/hooks';
import { DefaultLayout } from '@/layouts';
import { commonSelectors, deviceTypeSelector } from '@/store/reducers/commonSlice';
import { InferGetServerSidePropsType } from 'next';
import dynamic from 'next/dynamic';
import { getServerSideProps } from '..';

const AboutUsPage = ({ deviceType }: InferGetServerSidePropsType<typeof getServerSideProps>) => {
	const { dataBanner } = useAppSelector(commonSelectors);
	const deviceTypeCheck = useAppSelector(deviceTypeSelector);
	const isMobile = (deviceTypeCheck ?? deviceType) === DeviceType.MOBILE;
	const IMAGE_MOCKUP = [
		'https://www.nppngaliem.com/img/about/intro1.jpg',
		'https://www.nppngaliem.com/img/about/intro2.jpg',
		'https://www.nppngaliem.com/img/about/intro3.jpg',
		'https://www.nppngaliem.com/img/about/intro4.jpg',
		'https://www.nppngaliem.com/img/about/intro5.jpg',
		'https://www.nppngaliem.com/img/about/intro6.jpg',
	];
	const REASON_CHOOSE_IMAGES_MOCKUP = [
		'https://www.nppngaliem.com/img/about/whychoose/why1.jpg',
		'https://www.nppngaliem.com/img/about/whychoose/why2.jpg',
		'https://www.nppngaliem.com/img/about/whychoose/why3.jpg',
		'https://www.nppngaliem.com/img/about/whychoose/why4.jpg',
	];

	return (
		<DefaultLayout
			seoProps={{ title: 'Giới thiệu | Nga Liem', openGraph: { title: 'Giới thiệu | Nga Liem' } }}
			forceTitleRender
		>
			{isMobile ? (
				<div className='w-full h-[200px]'>
					<ImageCustom
						fill
						src={dataBanner.data?.data?.[0]?.image}
						className='!h-full object-contain'
					/>
				</div>
			) : (
				// <Banner dataBanner={dataBanner.data} />
				<></>
			)}

			<div className='pt-4 space-y-4 lg:pt-16 lg:space-y-16'>
				<section className='lg:container px-2.5 lg:px-0'>
					<div className='flex flex-col lg:flex-row lg:items-center lg:justify-between'>
						<h3 className='lg:flex-[30%] lg:max-w-[30%] text-primary font-bold text-large lg:text-3xl lg:leading-[50px]'>
							NGA LIÊM LÀ AI ?
						</h3>
						<span className='lg:flex-[55%] lg:max-w-[55%] text-small lg:text-medium xl:text-large font-normal leading-6 lg:leading-6 lg:leading-10'>
							Trong kỉ nguyên 4.0 phát triển vượt bật như hiện nay, các khối ngành kinh tế - khoa
							học kĩ thuật ngày càng phát triển năng động và hiện đại hóa. Cùng với sự đổi mới liên
							tục trong các sản phẩm và tính cấp thiết về chất lượng hàng hóa phải được đặt lên hàng
							đầu. Đó là lí do Nga Liêm được ra đời.
						</span>
					</div>
				</section>
				<section className='lg:container bg-primary'>
					<div className='grid grid-cols-3 gap-[10px] lg:gap-9 px-[30px] lg:px-32'>
						{IMAGE_MOCKUP?.map((img, index) => (
							<div
								className='relative w-full h-[100px] lg:h-full aspect-square overflow-hidden group'
								key={index}
							>
								<ImageCustom
									src={img}
									fill
									className='object-cover !h-full group-hover:scale-105 duration-300 transition-all'
								/>
							</div>
						))}
					</div>
				</section>
				<section className='lg:container px-2.5 lg:px-0 pb-8 lg:pb-32'>
					<div className='grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-24'>
						<div className='grid grid-cols-3 gap-6 order-2 lg:order-none'>
							{REASON_CHOOSE_IMAGES_MOCKUP?.map((el, index) => (
								<div
									className={classnames([
										`relative w-full min-h-[150px] lg:min-h-[250px] overflow-hidden group`,
										index === 0 || index === 3 ? '' : 'col-span-2',
									])}
									key={index}
								>
									<ImageCustom
										src={el}
										fill
										className='object-cover rounded-lg !h-full group-hover:scale-105 duration-300 transition-all'
									/>
								</div>
							))}
						</div>
						<div className='flex items-end order-1 lg:order-none'>
							<article className='flex lg:justify-center flex-col h-full space-y-6'>
								<h3 className='text-primary font-bold uppercase text-large mt-4 lg:mt-0 lg:text-3xl lg:leading-[50px]'>
									Tại Sao Lại Chọn Nga Liêm
								</h3>
								<div className='text-small lg:text-medium xl:text-large font-normal leading-6 lg:leading-10'>
									<p className='mb-6'>
										Lí do tại sao bạn nên chọn Nga Liêm thay vì các đơn vị kinh doanh khác ? Đơn
										giản là vì Chúng tôi luôn đáp ứng tất cả hàng hóa mà khách hàng mong muốn, đầy
										đủ các ngành hàng và dịnh vụ mà theo yêu cầu của đối tác. Cùng với sản phẩm chất
										lượng và giá thành hợp lí. Từ đó, chúng ta có một cái nhìn đa chiều hơn về khối
										ngành kinh doanh, cơ cấu hoạt động và quy trình mua bán mà công ty chúng tôi
										cung cấp ra thị trường.
									</p>
									<p>
										Là một trong những nhà phân phối hàng đầu khu vực hiện nay. Trong ngành điện có
										cáp điện Cadivi, Daphaco. Thiết bị điện Panasonic, Sino – Vanlock, Schneider,
										Rạng Đông, Philips, Điện Quang, Senko. Ngành nước dân dụng có thương hiệu Bình
										Minh, Hoa Sen, Đạt Hòa, Đồng Nai, Đệ Nhất, ... … cùng với nhiều thương hiệu khác
										góp mặt trong các ngành nghề khác nhau do Nga Liêm phân phối.
									</p>
								</div>
							</article>
						</div>
					</div>
				</section>
				<section className='mt-[60px]'>
					<div className='container w-full max-w-[1100px] md:max-w-[1200px] 2xl:max-w-[1390px] '>
						<div className='bg-primary overflow-hidden relative text-white w-full max-h-[330px] md:max-h-fit md:h-[700px] lg:h-[850px] '>
							<div className='flex'>
								<div className='w-1/2 pl-[16px] md:w-[70%] md:pl-[80px] lg:pl-[100px] '>
									<div className='content pr-[12px] py-[12px] md:py-[60px] '>
										<h3 className='max-w-[910px] font-bold text-large lg:text-3xl lg:leading-[50px]'>
											Câu Chuyện Về Nga Liêm
										</h3>
										<p className='max-w-[910px] text-justify text-small pt-4 lg:text-medium xl:text-large font-normal lg:leading-10'>
											Sau 16 năm nỗ lực xây dựng và phát triển, Nga Liêm đã có 5 đơn vị trực thuộc.
											Có 3 chi nhánh công ty tại tỉnh thành, 2 đơn vị trưng bày và phân phối hàng
											hóa ra thị trường. Cùng với mong muốn mở rộng hơn nữa để phục vụ quý khách
											hàng ngày một tốt hơn.
										</p>
									</div>
								</div>
								<div className='w-1/2 relative flex pl-[16px] pt-[60px] md:hidden '>
									<div className='img-wrapper w-full'>
										<ImageCustom
											className='w-full h-full object-cover'
											src={'https://www.nppngaliem.com/img/about/story/story1.jpg'}
											alt=''
											fill
										/>
									</div>
								</div>
							</div>
							<div className='img-wrapper w-full h-[550px] hidden absolute bottom-0 md:block md:right-[-80px] lg:right-[-100px] '>
								<ImageCustom
									fill
									src={'https://www.nppngaliem.com/img/about/story/story1.jpg'}
									alt=''
									className='w-full !h-full object-cover'
								/>
							</div>
						</div>
					</div>
				</section>
				<section className='pt-[30px] lg:pt-[60px]'>
					<div className='px-2.5 lg:px-0 lg:container w-full max-w-[1100px] md:max-w-[1200px] 2xl:max-w-[1390px] '>
						<div className='wrapper'>
							<h3 className='w-full text-primary text-center font-bold text-large lg:text-3xl lg:leading-[50px]'>
								Giá Trị Của Nga Liêm
							</h3>
							<h5 className='mx-auto text-center max-w-full lg:max-w-[68%] text-small pt-4 lg:text-medium xl:text-large font-normal leading-6 lg:leading-10'>
								Nga Liêm sở hữu một đội ngũ nhân viên hùng hậu và có chuyên môn cao. Cùng với sự
								nhiệt huyết từ các bạn trẻ và niềm tin đem đến sản phẩm chất lượng cho khách hàng.
							</h5>
						</div>
					</div>
					<div className='mt-[30px] md:mt-[60px] '>
						<div className='flex'>
							<div className='relative w-1/3 aspect-[12/15] min-h-[200px]'>
								<div className='content w-full h-full absolute left-0 top-0 z-[1] p-[12px] md:p-[30px] '>
									<p className='font-bold text-large lg:text-3xl lg:leading-[50px] text-base-100'>
										Giá phải chăng
									</p>
									<p className='text-small pt-4 lg:text-medium xl:text-large font-normal leading-6 lg:leading-10 text-base-100'>
										Chúng tôi cung cấp dịch vụ, sản phẩm tốt nhất với mức giá cạnh tranh trên thị
										trường
									</p>
								</div>
								<div className='absolute top-0 left-0 w-full h-full z-[0]'>
									<ImageCustom
										className='w-full h-full object-cover filter brightness-75'
										src='https://www.nppngaliem.com/img/about/value/value1.jpg'
										alt=''
										fill
									/>
								</div>
								<div className='bg-overlay3 absolute top-0 left-0 w-full h-full z-[0]'></div>
							</div>
							<div className='relative w-1/3 aspect-[12/15] min-h-[200px]'>
								<div className='content w-full h-full absolute left-0 top-0 z-[1] p-[12px] md:p-[30px] '>
									<p className='font-bold text-large lg:text-3xl lg:leading-[50px] text-base-100'>
										Giao hàng nhanh chóng
									</p>
									<p className='text-small pt-4 lg:text-medium xl:text-large font-normal leading-6 lg:leading-10 text-base-100'>
										Chúng tôi đảm bảo xử lý và giao hàng cho bạn nhanh chóng kể từ khi tiếp nhận đơn
										hàng
									</p>
								</div>
								<div className='absolute top-0 left-0 w-full h-full z-[0]'>
									<ImageCustom
										className='w-full h-full object-cover filter brightness-75'
										src='https://www.nppngaliem.com/img/about/value/value2.jpg'
										alt=''
										fill
									/>
								</div>
								<div className='bg-overlay3 absolute top-0 left-0 w-full h-full z-[0]'></div>
							</div>
							<div className='relative w-1/3 aspect-[12/15] min-h-[300px] lg:min-h-[200px]'>
								<div className='content w-full h-full absolute left-0 top-0 z-[1] p-[12px] md:p-[30px] '>
									<p className='font-bold text-large lg:text-3xl lg:leading-[50px] text-base-100'>
										Hỗ trợ nhiệt tình
									</p>
									<p className='text-small pt-4 lg:text-medium xl:text-large font-normal leading-6 lg:leading-10 text-base-100'>
										Chúng tôi đảm bảo hỗ trợ cho khách hàng tốt nhất có thể, đảm bảo khách hàng luôn
										vui vẻ, hài lòng nhất
									</p>
								</div>
								<div className='absolute top-0 left-0 w-full h-full z-[0]'>
									<ImageCustom
										className='w-full h-full object-cover filter brightness-75'
										src='https://www.nppngaliem.com/img/about/value/value3.jpg'
										alt=''
										fill
									/>
								</div>
								<div className='bg-overlay3 absolute top-0 left-0 w-full h-full z-[0]'></div>
							</div>
						</div>
					</div>
				</section>
			</div>
		</DefaultLayout>
	);
};

export default dynamic(() => Promise.resolve(AboutUsPage), {
	ssr: false,
});
